import { TradeList } from "../../../data/trading/trades/types";
import React from "react";
import { LocalizationContext } from "../../../core/localization/Localization";
import { Column } from "material-table";
import { useOrderMarketOptionsTranslator } from "../../../data/trading/orders/hooks/useOrderMarketOptions";
import { TurnocateText } from "../../trading/orders/columRenderers";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export const useTradeColumns = () => {
	const { getString, getDateString, getDateTimeString, getFormatedNumberString } = React.useContext(LocalizationContext);
	const marketTranslator = useOrderMarketOptionsTranslator();

	const theme = useTheme();
	const screenExtraSmall = useMediaQuery(theme.breakpoints.only('xs'));

	return React.useMemo(
		() => [
			{
				title: getString("tradeNo"),
				field: "tradeNo",
				sorting: false,
				width: "70px",
				cellStyle: {
					maxWidth: "70px",
				},
				headerStyle: {
					maxWidth: "70px",
				},
				hidden: screenExtraSmall,
			},
			{
				title: screenExtraSmall ? getString("annualTradeReportDate") : getString("tradeTime"),
				render: (trade) => getDateString(trade.tradeTime, "DD.MM.YYYY"),
				sorting: false,
				width: screenExtraSmall ? "120px" : "160px" ,
				cellStyle: {
					maxWidth: screenExtraSmall ? "120px" : "160px",
					minWidth: screenExtraSmall ? "120px" : "160px",
					width: screenExtraSmall ? "120px" : "160px",
				},
				headerStyle: {
					maxWidth: screenExtraSmall ? "120px" : "160px",
					minWidth: screenExtraSmall ? "120px" : "160px",
					width: screenExtraSmall ? "120px" : "160px",
				},
			},
			{
				title: getString("tradeProdName"),
				field: "prodName",
				sorting: false,
			},
			{
				title: getString("clientNameSell"),
				render: trade => <TurnocateText text={trade.clientNameSell} maxChars={18} />,
				sorting: false,
				width: "180px",
				cellStyle: {
					maxWidth: "180px",
					width: "180px",
					whiteSpace: "nowrap",
				},
				headerStyle: {
					maxWidth: "180px",
					width: "180px",
				},
				hidden: screenExtraSmall,
			},
			{
				title: getString("clientNameBuy"),
				render: trade => <TurnocateText text={trade.clientNameBuy} maxChars={18} />,
				sorting: false,
				width: "180px",
				cellStyle: {
					maxWidth: "180px",
					width: "180px",
					whiteSpace: "nowrap",
				},
				headerStyle: {
					maxWidth: "180px",
					width: "180px",
				},
				hidden: screenExtraSmall,
			},
			{
				title: getString("tradeQty"),
				render: trade => `${getFormatedNumberString(trade.qty)} ${trade.unitDescr}`,
				sorting: false,
				cellStyle: {
					minWidth: "130px",
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				headerStyle: {
					minWidth: "130px",
					textAlign: "end",
				},
			},
			{
				title: getString("orderPrice"),
				render: trade => getFormatedNumberString(trade.price, true),
				sorting: false,
				cellStyle: {
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				headerStyle: {
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				hidden: screenExtraSmall,
			},
			{
				title: getString("orderMarket"),
				render: trade => marketTranslator(trade.market),
				sorting: false,
				hidden: screenExtraSmall,
			},
			{
				title: getString("tradeStatusDescr"),
				field: "statusDescr",
				sorting: false,
				hidden: screenExtraSmall,
			},
		],
		[getString, getDateTimeString, marketTranslator, screenExtraSmall]
	) as Column<TradeList>[];
};
